// API helpers for the Teams (v2.1 "Teams") module. All calls go through the
// gateway /bot prefix to the trooprbot backend. Cookies are sent globally
// (axios withCredentials is set in index.js).
import axios from 'axios';

const base = (wId) => `/bot/api/w/${wId}/workspace-teams`;

export const listTeams = (wId, all = false) =>
  axios.get(`${base(wId)}${all ? '?all=true' : ''}`);

export const getTeam = (wId, teamId) => axios.get(`${base(wId)}/${teamId}`);

export const createTeam = (wId, payload) => axios.post(base(wId), payload);

export const updateTeam = (wId, teamId, payload) =>
  axios.put(`${base(wId)}/${teamId}`, payload);

// Create (or idempotently update) a team's AI Automated Standup. Hits troopr-api
// directly (createNewTeamSync) — the same endpoint legacy creation used — with
// engine:'ai'. Server-side it upserts the per-team singleton, so calling this
// repeatedly (e.g. re-running onboarding) never makes duplicates.
export const saveAiStandup = (wId, payload) =>
  axios.post(`/api/w/${wId}/createNewTeamSync`, payload);

export const archiveTeam = (wId, teamId) =>
  axios.delete(`${base(wId)}/${teamId}`);

// Preview the members that would be pulled from a Slack channel / Jira project.
export const previewMembers = (wId, source, id) =>
  axios.get(`${base(wId)}/source/preview`, { params: { source, id } });

// Slack channels available in the workspace (for the channel picker).
export const getSlackChannels = (wId) =>
  axios.get(`/bot/api/w/${wId}/team/slack/getChannels`);

// Jira projects from the workspace's connected Jira (for the team project picker).
export const getJiraProjects = (wId) =>
  axios.get(`/bot/api/w/${wId}/jira/project`);

// Jira boards in the workspace's connected Jira (for the current-work picker).
export const getJiraBoards = (wId) =>
  axios.get(`/bot/api/w/${wId}/jira/getAllBoardsApi`);

// Sprints for a given board (for the "Active sprint" current-work option).
export const getBoardSprints = (wId, boardId) =>
  axios.get(`/bot/api/w/${wId}/jira/getBoardsSprints/${boardId}`);

// Live count of issues matching a JQL, using the workspace/admin token.
export const getJqlCount = (wId, jql) =>
  axios.get(`/bot/api/w/${wId}/jira/jql/count`, { params: { jql } });
